import Section from "./Section";
import {H3} from "../Headlines";
import Paragraph from "../Paragraph";
import {PresentationChartLineIcon} from "@heroicons/react/24/solid";
import {ZurLeistungsuebersicht} from "./Leistungen";


interface Props {
    activeLeistung?: string | undefined;
    inListing?: boolean;
}

export default function Waermepumpencheck({activeLeistung, inListing = true}: Props) {
    const name = 'waermepumpencheck';

    return <>
        {(activeLeistung === name || inListing) &&
            <Section id={name} className={'md:!pt-16 !pt-24'}>
                <div className={'flex justify-center'}>
                    <PresentationChartLineIcon className={'text-green-600 h-20'}/>
                </div>
                <H3 id={'waermepumpencheck-headline'} className={'mt-4'}>Der Wärmepumpencheck</H3>
                <Paragraph className={'mt-8 font-bold'}>
                    Ist eine Wärmepumpe die richtige Lösung für Ihr Gebäude? Wir finden es für Sie heraus!
                </Paragraph>
                <Paragraph className={'mt-8'}>
                    Sie möchten wissen, ob eine Wärmepumpe in Ihrer Liegenschaft effizient betrieben werden kann?
                    Wir analysieren Ihr Gebäude, berechnen die Heizlast und ermitteln die erforderliche
                    Vorlauftemperatur für
                    eine präzise und wirtschaftliche Auslegung Ihrer Wärmepumpe.
                </Paragraph>
                <Paragraph className={'mt-8'}>
                    Zusätzlich unterstützen wir Sie bei der Beantragung von Fördermitteln,
                    einschließlich des <span className={'font-bold text-nowrap'}>KfW-Programms 458</span>,
                    um Ihre Investition optimal abzusichern und mit Fördermitteln zu ergänzen.
                </Paragraph>
                {inListing && <ZurLeistungsuebersicht/>}
            </Section>
        }
    </>
}